import { createAction, props } from '@ngrx/store';

import { PagedResponse, SortOptions } from '../general/models/general';
import { createFailure, createSuccess } from '../utils/action-utils';
import { ILibraryData,Library } from './models/Library';
import {
  IRiskCompliance,
  RiskEdit,
  Risks,
  RisksFromVulnerability,
  RisksTasks,
} from './models/Risks';

// Get Risks Register Actions //
const getRisksRegisterKey = '[Risks] Get All Register Risks';
export const getRisksRegister = createAction(
  getRisksRegisterKey,
  props<{
    sortOptions?: SortOptions;
    searchTerm?: string;
    filters?: string;
    pageNumber?: number;
  }>(),
);
export const getRisksRegisterSuccess = createAction(
  createSuccess(getRisksRegisterKey),
  props<{ pagedRisksRegister: PagedResponse<Risks> }>(),
);
export const getRisksRegisterFailure = createAction(
  createFailure(getRisksRegisterKey),
  props<{ error: any }>(),
);

// Add Risks Register Actions //
const addRisksRegisterKey = '[Risks] Add Risk Register';
export const addRisksRegister = createAction(
  addRisksRegisterKey,
  props<{ riskRegister: Risks }>(),
);
export const addRisksRegisterSuccess = createAction(
  createSuccess(addRisksRegisterKey),
  props<{ riskRegister: Risks }>(),
);
export const addRisksRegisterFailure = createAction(
  createFailure(addRisksRegisterKey),
  props<{ error: any }>(),
);

// Update Risk Register Actions //
const updateRiskRegisterKey = '[Risks] Update Risk Register';
export const updateRiskRegister = createAction(
  updateRiskRegisterKey,
  props<{ riskId: string; newBody: Partial<RiskEdit> }>(),
);
export const updateRiskRegisterSuccess = createAction(
  createSuccess(updateRiskRegisterKey),
  props<{ riskId: string; newBody: Partial<RiskEdit> }>(),
);
export const updateRiskRegisterFailure = createAction(
  createFailure(updateRiskRegisterKey),
  props<{ error: any }>(),
);

// Get Risks Register By Id Actions //
const getRisksRegisterByIdKey = '[Risks] Get Risk Register By Id';
export const getRisksRegisterById = createAction(
  getRisksRegisterByIdKey,
  props<{ risksId: string }>(),
);
export const getRisksRegisterByIdSuccess = createAction(
  createSuccess(getRisksRegisterByIdKey),
  props<{ riskRegisterById: Risks }>(),
);
export const getRisksRegisterByIdFailure = createAction(
  createFailure(getRisksRegisterByIdKey),
  props<{ error: any }>(),
);

// Get Risks Library Actions //
const getRisksLibraryKey = '[Risks] Get All Library Risks';
export const getRisksLibrary = createAction(
  getRisksLibraryKey,
  props<{
    sortOptions?: SortOptions;
    searchTerm?: string;
    pageNumber?: number;
  }>(),
);
export const getRisksLibrarySuccess = createAction(
  createSuccess(getRisksLibraryKey),
  props<{ pagedRisksLibrary: PagedResponse<Risks> }>(),
);
export const getRisksLibraryFailure = createAction(
  createFailure(getRisksLibraryKey),
  props<{ error: any }>(),
);

// Get Risks Library By Id Actions //
const getRisksLibraryByIdKey = '[Risks] Get Risk Library By Id';
export const getRisksLibraryById = createAction(
  getRisksLibraryByIdKey,
  props<{ riskLibraryById: string }>(),
);
export const getRisksLibraryByIdSuccess = createAction(
  createSuccess(getRisksLibraryByIdKey),
  props<{ riskLibraryById: Library }>(),
);
export const getRisksLibraryByIdFailure = createAction(
  createFailure(getRisksLibraryByIdKey),
  props<{ error: any }>(),
);

// Delete Risk Register Actions //
const deleteRiskRegisterKey = '[Risks] Delete Risk';
export const deleteRiskRegister = createAction(
  deleteRiskRegisterKey,
  props<{ riskId: string }>(),
);
export const deleteRiskRegisterSuccess = createAction(
  createSuccess(deleteRiskRegisterKey),
  props<{ riskId: string }>(),
);
export const deleteRiskRegisterFailure = createAction(
  createFailure(deleteRiskRegisterKey),
  props<{ error: any }>(),
);

// Get Risk Vulnerability By Id Actions //
const getRiskVulnerabilityByIdKey = '[Risks] Get Risk From Vulnerability By Id';
export const getRiskVulnerabilityById = createAction(
  getRiskVulnerabilityByIdKey,
  props<{
    id: string;
    sortOptions?: SortOptions;
    searchTerm?: string;
    filters?: string;
    pageNumber?: number;
  }>(),
);
export const getRiskVulnerabilityByIdSuccess = createAction(
  createSuccess(getRiskVulnerabilityByIdKey),
  props<{
    pagedRiskVulnerabilityById: PagedResponse<RisksFromVulnerability>;
  }>(),
);
export const getRiskVulnerabilityByIdFailure = createAction(
  createFailure(getRiskVulnerabilityByIdKey),
  props<{ error: any }>(),
);

// Get Risk Tasks By Id Actions //
const getRiskTasksByIdKey = '[Risks] Get Risk Tasks By Id';
export const getRiskTasksById = createAction(
  getRiskTasksByIdKey,
  props<{
    id: string;
    sortOptions?: SortOptions;
    searchTerm?: string;
    filters?: string;
    pageNumber?: number;
    pageSize?: number;
  }>(),
);
export const getRiskTasksByIdSuccess = createAction(
  createSuccess(getRiskTasksByIdKey),
  props<{ pagedRiskTasksById: PagedResponse<RisksTasks> }>(),
);
export const getRiskTasksByIdFailure = createAction(
  createFailure(getRiskTasksByIdKey),
  props<{ error: any }>(),
);

// Clear Risk Register Actions //
const clearRiskRegisterKey = '[Risks] Clear Risk Register';
export const clearRiskRegister = createAction(clearRiskRegisterKey);

// Get Risks Library Data Actions //
const getRisksLibraryDataKey = '[Risks] Get All Library Risks Data';
export const getRisksLibraryData = createAction(
  getRisksLibraryDataKey,
  props<{
    searchTerm?: string;
    pageNumber?: number;
  }>(),
);
export const getRisksLibraryDataSuccess = createAction(
  createSuccess(getRisksLibraryDataKey),
  props<{ pagedRisksLibraryData: PagedResponse<ILibraryData> }>(),
);
export const getRisksLibraryDataFailure = createAction(
  createFailure(getRisksLibraryDataKey),
  props<{ error: any }>(),
);

// Get Risk Compliance By Id Actions //
const getRisksComplianceByIdKey = '[Risks] Get Risk Compliance By Id';
export const getRisksComplianceById = createAction(
  getRisksComplianceByIdKey,
  props<{ risksId: string }>(),
);
export const getRisksComplianceByIdSuccess = createAction(
  createSuccess(getRisksComplianceByIdKey),
  props<{ riskComplianceById: IRiskCompliance }>(),
);
export const getRisksComplianceByIdFailure = createAction(
  createFailure(getRisksComplianceByIdKey),
  props<{ error: any }>(),
);
